import { Component, OnInit } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { UsuariModel } from '../../admin/models/admin.model';
import { AuthService } from '../auth.service';
// import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { AlertType } from 'src/app/shared/alert.model';
import { GitihService } from 'src/app/gitih/services/gitih.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public frm: FormGroup;
  usuari: UsuariModel = new UsuariModel();
  recordar: boolean = false;

  inscripcioOberta = true;
  avui:Date = new Date();

  constructor(
      private auth: AuthService,
      private router: Router,
      private alert: AlertService,
      private popup: DialogService,
      private githiService: GitihService) { }

  ngOnInit() {
  }

  login (frm: NgForm) {
    if (frm.invalid) { return }

    this.alert.info('Connectant... Esperi si us plau');    
    
    // console.log(JSON.stringify(this.usuari));

    this.auth.login( this.usuari )
      .subscribe( (res:any) => {
        this.router.navigateByUrl('/');
      },
      (err) => {        
        console.log("ERROR login.compoment.ts :: " + JSON.stringify(err));
        if (err.statusText && err.status==0) {
          this.popup.show('Error identificació', 'Servidor no respon.', AlertType.Error);    
        }
        else {
          this.popup.show('Error identificació', 'Usuari o contrasenya incorrecta', AlertType.Error);    
        }
        this.usuari.autoritzat = false;
      })
  }
}
